module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"heatingTypeTitle":"Typ","shareTitle":"Anteil","energyCalibration":"Endenergie Kalibrierung","addHeatingButton":"Wärmeerzeuger hinzufügen","noHeatingDefined":"Keine Wärmeerzeuger","totalShareWarning":"Summe Anteil muss exakt 100% betragen!","total":"Total","shareInfoBoxTitle":"Anteil","shareInfoBox":"Anteil der Wärme, der durch diesen Wärmeerzeuger bereitgestellt wird."}}')
  delete Component.options._Ctor
}
